import { toast } from 'sonner';

const AUTH_PAGES = ['/login', '/forgot-password', '/reset-password', '/set-password'];
const recentToasts = new Map();

const shouldShowToast = (message, type) => {
  const key = `${type}-${message}`;
  const now = Date.now();
  const lastShown = recentToasts.get(key);

  if (lastShown && now - lastShown < 2500) {
    return false;
  }

  recentToasts.set(key, now);
  setTimeout(() => recentToasts.delete(key), 5000);
  return true;
};

export const toastService = {
  loading: (message, options = {}) => {
    return toast.loading(message, options);
  },

  info: (message, options = {}) => {
    if (!options.id && !shouldShowToast(message, 'info')) {
      return;
    }
    return toast.info(message, {
      duration: 2500,
      ...options
    });
  },

  success: (message, options = {}) => {
    if (!options.id && !shouldShowToast(message, 'success')) {
      return;
    }
    return toast.success(message, {
      duration: 2000,
      ...options
    });
  },

  warning: (message, options = {}) => {
    if (!options.id && !shouldShowToast(message, 'warning')) {
      return;
    }
    return toast.warning(message, {
      duration: 3000,
      ...options
    });
  },

  error: (message, options = {}) => {
    if (AUTH_PAGES.includes(window.location.pathname)) {
      return;
    }

    if (!options.id && !shouldShowToast(message, 'error')) {
      return;
    }

    return toast.error(message, {
      duration: 3000,
      ...options
    });
  },

  promise: (promise, { pending, success, error }, options = {}) => {
    return toast.promise(promise, {
      loading: pending || 'Processing...',
      success: success || 'Success!',
      error: error || 'Something went wrong.',
      ...options
    });
  },

  notifyPromise: (promise, messages, options = {}) => {
    const defaultMessages = {
      pending: 'Processing...',
      success: 'Success!',
      error: 'Something went wrong.'
    };
    const finalMessages = { ...defaultMessages, ...messages };

    toast.promise(promise, {
      loading: finalMessages.pending,
      success: finalMessages.success,
      error: finalMessages.error,
      ...options
    });

    return promise;
  },

  dismiss: toastId => {
    if (toastId) {
      toast.dismiss(toastId);
    } else {
      toast.dismiss();
    }
  }
};
